import { Injectable, OnInit, EventEmitter, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { SignalrServiceLegacy } from './signalr.service.legacy';
import { LocalizationService } from './localization.service';
import { UserHelper } from '@helpers/user.helper';
import { UiHelper } from '@helpers/ui.helper';
import { DataHelper } from '@helpers/data.helper';
import { TranslateService } from '@services/translate.service';
import { DOCUMENT } from '@angular/common';
import { CashoutURL } from '@environments/environment';
import { pushToDataLayer } from '@helpers/gtm.util';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { casinoFavAddAndRemoveApiType, casinoFavGamesListApiType, casinoGamesListApiType, casinoMostFavoritesApiType } from '@components/casino/casino.model';
import { OddModel } from '@app/models/odd.model';

declare let betaluxBr;

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private _SignalrServiceLegacy: SignalrServiceLegacy,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public _UserHelper: UserHelper,
    private _UiHelper: UiHelper,
    private _DataHelper: DataHelper,
    @Inject(DOCUMENT) document
  ) {
    this._SignalrServiceLegacy.init();
    this.getSelectedOdds();

    this._UiHelper.isActiveSignalrConnectionListener.subscribe(state => {
      this.signalrConnection(state);
    });

    this._UiHelper.apiServiceAddOddEmitter.subscribe((markets: any) => {
      this.addMarketToSlip(markets);
    });
  }

  private url_main = environment.isServe ? 'http://localhost:5001/API/api' : '/API';
  //private url_main = '/API';
  // for prod
  private url_login = environment.isServe ? 'http://localhost:5001/API/login' : '/Login';
  //private url_login = '/Login';

  private sliderUrl = this.url_main + '/Slider';
  private topWinnerUrl = this.url_main + '/TopWinners';
  private sidebannerUrl = this.url_main + '/SideBanner';
  private sportsUrl = this.url_main + '/Sports';
  private countriesUrl = this.url_main + '/Countries';
  private TourementsByCatIDUrl = this.url_main + '/TournamentsByCategoryId';
  private OutrightsByCatIDUrl = this.url_main + '/OutrightsByCategoryId';
  private addOddUrl = this.url_main + '/PickOdd';
  private bookingsUrl = this.url_main + '/Bookings';
  private transcationTypesUrl = this.url_main + '/TransactionTypes';
  private slipByDateUrl = this.url_main + '/Slips';
  private signInUrl = this.url_login + '/SignIn';
  private signOutUrl = this.url_login + '/SignOut';
  private getClientUrl = this.url_login + '/GetClient';
  private getClient2Url = this.url_login + '/GetClient2';
  private getForgotPasswordUrl = this.url_login + '/ForgetPassword';
  private getForgotPasswordUrl2 = this.url_login + '/ForgetPassword2';

  private changePasswordUrl = this.url_login + '/ChangePassword';
  private slipDetailUrl = this.url_main + '/SlipDetail';
  private couponDetailBySlipIdUrl = this.url_main + '/SlipOneBySlipId';
  private fixtureUrl = this.url_main + '/FixtureMobile';
  private eventDetailUrl = this.url_main + '/MatchOddsbyGroup';
  private eventUrl = this.url_main + '/match';
  private getAccountLockUrl = this.url_main + '/AccountLockCustomer';
  private getSelfLimitsUrl = this.url_main + '/SelfLimits';
  private saveSelfLimitsUrl2 = this.url_main + '/SaveCustomerSelfLimits2';
  private getCurrentSlipAmountUrl = this.url_main + '/CurrentSlipAmount';
  private getPlaceBetUrl = this.url_main + '/PlaceBet';
  private getSearchUrl = this.url_main + '/Search';
  private getSearchSlipNumberUrl = this.url_main + '/SearchSlipNumber';

  private getLoginRefresh = this.url_login + '/Refresh';
  private getSystemItemsUrl = this.url_main + '/SystemItems';
  private getSignUpUrl = this.url_login + '/SignUpB3';
  private getEmailCheck = this.url_login + '/EmailCheck';
  private getSaluteListUrl = this.url_login + '/GetSaluteFields';
  private getSignUpFieldsUrl = this.url_login + '/GetSignUpFields';

  private getCountryUrl2 = this.url_main + '/ComboCountry2';

  private getTaxRateUrl = this.url_login + '/GetTaxRate';
  private getCashOutPayUrl = this.url_main + '/CashOutPay';
  private getCashOutPayAnonUrl = this.url_main + '/CashOutPayAnonymous';
  private getCashOutPayJacktimeUrl = this.url_main + '/CashOutPayJacktime';
  private getWalletListUrl = this.url_login + '/CustomerWalletList2';
  private quickRegisterUrl = this.url_login + '/Quickregister';
  private switchWalletrUrl = this.url_login + '/SwitchWallet';
  private saveAffiliationUrl = this.url_login + '/SaveAffiliation';

  private refreshCurrentSlipUrl = this.url_main + '/RefreshCurrentSlip';

  private getAllWithdrawControlUrl = this.url_main + '/AllWithdrawControl';

  private getWithdrawBanksUrl = this.url_main + '/WithdrawBanks';
  private getBanksWithdrawUrl = this.url_main + '/BanksWithdraw';
  private getOutrightSportsUrl = this.url_main + '/OutrightSports';
  private getOutrightCategoriesUrl = this.url_main + '/OutrightCategories';
  private getOutrightEventsUrl = this.url_main + '/OutrightEvents';
  private getOutrightMatchOddsUrl = this.url_main + '/OutrightMatchOdds';
  private getOutrightMatchOddsbyTourIdUrl = this.url_main + '/OutrightMatchOddsbyTourId';
  private getGetCustomerTicketUrl = this.url_main + '/GetCustomerTicket';
  private getCustomerTicketDetailUrl = this.url_main + '/GetCustomerTicketDetail';
  private getAnswerTicketMessageUrl = this.url_main + '/AnswerTicketMessage';
  private getUploadtoAWSUrl = this.url_main + '/UploadtoAWS';
  private getGetCustomerOneUrl = this.url_main + '/CustomerOne';
  private getComboPhoneNumberUrl = this.url_main + '/ComboPhoneNumber';
  private getComboPasswordQuestionUrl = this.url_main + '/ComboPasswordQuestion';
  private getSaveCustomerDetailUrl = this.url_main + '/SaveCustomerDetail';
  private cashbackStatusUrl = this.url_main + '/CashbackStatus';
  private joinCashbackUrl = this.url_main + '/JoinCashback';
  private cashbackBalanceUrl = this.url_main + '/CashbackBalance';

  private getCloudFilesUrl = this.url_main + '/CloudFiles';
  private getUploaddocControl = this.url_main + '/UploadsFiles';
  private uploadDocumentToAWS = this.url_main + '/UploadDocumentToAWS';

  private getUnreadMessageUrl = this.url_main + '/GetUnreadMessage';
  private getPagebyTitleUrl = this.url_main + '/pagebytitle';
  private getMailConfirmUrl = this.url_login + '/MailConfirm';

  private getSearch4FavsUrl = this.url_main + '/Search4Favs';
  private recoverPasswordUrl = this.url_login + '/RecoveryPassword';
  private getScannerSlipDetailUrl = this.url_main + '/ScannerSlipDetail';
  private getScannerSlipOneBySlipIdAndPassUrl = this.url_main + '/ScannerSlipOneBySlipIdAndPass';
  private slipRestoreUrl = this.url_main + '/SlipRestore';
  private helpMailUrl = this.url_main + '/HelpMail';

  private getPlaceBetTempUrl = this.url_main + '/PlaceBetTemp';
  private AWSGetImageUrl = this.url_main + '/AWSGetImage';

  private getUploadtoAWSFromSupportUrl = this.url_main + '/UploadtoAWSFromSupport';
  private bookingLoginResultUrl = this.url_main + '/BookingLoginResult';
  private procCustomerQrCodeResultUrl = this.url_main + '/ProcCustomerQrCodeResult';
  private procAccountLockReasonResultUrl = this.url_main + '/ProcAccountLockReasonResult';
  private procAccountLockDayResultUrl = this.url_main + '/ProcAccountLockDayResult';
  private procCustomerAccountLockNewResultUrl = this.url_main + '/procCustomerAccountLockNewResult';

  private getProcCustomerBonusTrackerResultUrl = this.url_main + '/ProcCustomerBonusTrackerResult';
  private getProcCustomerBonusTracker1ResultUrl = this.url_main + '/ProcCustomerBonusTracker1Result';
  private getProcTournamentTopResultUrl = this.url_main + '/ProcTournamentTopResult';
  private getProcCustomerIBANUIDResultUrl = this.url_main + '/ProcCustomerIBANUIDResult';
  private ProcMatchStandingResultUrl = this.url_main + '/ProcMatchStandingResult';
  private ProcCustomerContractUrl = this.url_main + '/ProcCustomerContract';

  private getQuickRegisterUrl = 'API' + '/GetQuickregister';

  private postPasswordControl = this.url_main + '/passwordControl';
  private getSearchp1001Url = this.url_main + '/fixtureSearch';
  private getTransactionHistoryUrl = this.url_main + '/TransactionHistory';

  private antiForgeryToken = '';
  private getProcCustomerBonusOnlineTracker1ResultUrl = this.url_main + '/ProcCustomerBonusOnlineTracker1Result';
  private getResendConfirmationMailUrl = this.url_main + '/ResendConfirmationMail';
  private getOddComparisonUrl = this.url_main + '/getOddComparison';
  private sliderWebUrl = this.url_main + '/SliderWeb';
  private AutoWithdrawAutoReqUrl = this.url_main + '/WithdrawAutoReq';
  private customerCashoutInfoUrl = this.url_login + '/CustomerCashoutInfo';
  private getTopListTicketUrl = this.url_main + '/TopSlipList';
  private postWithDrawCancelUrl = this.url_main + '/WithDrawCancel';
  private liveStreamUrl = this.url_main + '/liveStream';
  private betradarLiveStreamUrl = '/Betradar/LiveStream/GetEvents';
  private betradarStreamVideoUrl = 'Betradar/LiveStream/GetStream';
  private customerSlipDetailTempUrl = this.url_main + '/CustomerSlipDetailTemp';

  private casinoProviderList = this.url_main + '/casino/v2/GetProviders';
  private casinoGameList = this.url_main + '/casino/v2/GetGamesProviderOrCategory';
  private casinoGetCategories = this.url_main + '/casino/v2/GetCategories';
  private casinoSoftmayaUrl = this.url_main + '/casino/v2/GameLaunch';
  private casinoFavoriteByCustomerUrl = this.url_main + '/casino/v2/FavoriteByCustomer';
  private casinoFavoriteAddUrl = this.url_main + '/casino/v2/Favorite';
  private casinoMostFavoritesUrl = this.url_main + '/casino/v2/FavoriteGames';
  private casinoSliderUrl = this.url_main + '/casino/v2/GetSliderList';
  private getFixturewithTeamListUrl = this.url_main + '/getFixturewithTeamList';
  private CustomerTeamListUrl = this.url_main + '/CustomerTeamList';
  private CustomerTeamUIDUrl = this.url_main + '/CustomerTeamUID';
  private procFixtureUrl = this.url_main + '/FavFixture';
  private mySlipLiveMatchListUrl = this.url_main + '/mySlipLiveMatchList';
  private getCasinoRegisterInfoUrl = 'API' + '/CustomerDataCheck';
  private bonusBoostFreeBetUrl = this.url_login + '/bonusBoostFreeBet';
  private getPromotionPageUrl = 'API' + '/GetPromotionPage';
  private getPromotionCountUrl = 'API' + '/GetPromotionCount';
  private customerSlipWildCardUrl = 'API' + '/CustomerSlipWildCard';
  private LiveStreamEventsUrl = 'LiveStream/GetLiveEvents';
  private liveStreamVideoUrl = 'LiveStream/GetStreamUrl';
  // Selected Odds
  selectedOddsEvent: EventEmitter<any> = new EventEmitter();

  slipCurrents = [];
  flagCurrentSlipAmount = false;

  flagCashoutSlipsExternal = false;
  dataCashoutSlipsExternal;

  // refresh slip
  flag_control_refreshcurrentslip = 0;
  seonResult;
  setSeon(e) {
    if (environment.isSeon && environment.siteUrl) {
      this._DataHelper
        .getSeon(e)
        .then(data => {
          this.seonResult = data;
        })
        .catch(error => {
          console.error('Error retrieving Seon data:', error);
        });
    }
  }
  setAntiForgeryToken(e) {
    this.antiForgeryToken = e;
    this.setSeon(e);
  }

  getSlider(v: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.sliderUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTopWinner(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.topWinnerUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then((r: { today: any[]; week: any[]; month: any[] }) => {
        const activeTab = null;
        const data = {
          today: [],
          week: [],
          month: [],
        };

        Object.values(r).forEach((item, index) => {
          data[Object.keys(r)[index]] = item.map((slipItem, index) => {
            slipItem.isOpen = false;
            slipItem.totalOdd = slipItem.SlipDetails.reduce((acc, slipRow) => {
              return acc * slipRow.OddValue;
            }, 1);
            return slipItem;
          });
        });

        this._DataHelper.topWinnerData = {
          1: data.today,
          2: data.week,
          3: data.month,
        };
        this._DataHelper.topWinnerDataActiveTab =
          this._DataHelper.topWinnerData[1] && this._DataHelper.topWinnerData[1].length > 0
            ? 1
            : this._DataHelper.topWinnerData[2] && this._DataHelper.topWinnerData[2].length > 0
            ? 2
            : this._DataHelper.topWinnerData[3] && this._DataHelper.topWinnerData[3].length > 0
            ? 3
            : 0;

        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSideBanner(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.sidebannerUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSports(dayFilter = 24): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.sportsUrl}/${this._LocalizationService.LANGID}/${dayFilter}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCountriesBySportsID(dayFilter = 24, _sportsID): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.countriesUrl}/${_sportsID}/${this._LocalizationService.LANGID}/${dayFilter}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTourementsByCountryID(dayFilter = 24, _sportsID, _countriesID): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.TourementsByCatIDUrl}/${_sportsID}/${_countriesID}/${this._LocalizationService.LANGID}/${dayFilter}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getOutrightsByCountryID(dayFilter = 24, _sportsID, _countriesID): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.OutrightsByCatIDUrl}/${_sportsID}/${_countriesID}/${this._LocalizationService.LANGID}/${dayFilter}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getFixturewithTeamList(_sportIds, _categoryIds, teamId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    // sport filter
    const _tournamentIds = teamId;
    return this.http
      .get(
        `${this.getFixturewithTeamListUrl}/${_sportIds}/${_categoryIds}/${_tournamentIds}/${this._DataHelper.leftMenuSportDayFilter}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`,
        { headers }
      )
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getFixture(_sportIds = '0', _categoryIds = '0', teamId?): Promise<any> {
    if (teamId) {
      return this.getFixturewithTeamList(_sportIds, _categoryIds, teamId);
    } else {
      const headers = new HttpHeaders().set('Content-Type', 'application/json');

      // sport filter

      let _tournamentIds = '';
      if (this._DataHelper.LeagueData != undefined && this._DataHelper.LeagueData.length > 0) {
        _sportIds = '';
        _categoryIds = '';
        _tournamentIds = '';

        this._DataHelper.LeagueData.forEach(tournament => {
          _sportIds += tournament.SportId + '|';
          _categoryIds += tournament.CategoryId + '|';
          _tournamentIds += tournament.TournamentId + '|';
        });
      } else {
        // _categoryIds = "0";
        _tournamentIds = '0';
      }
      // sport filter

      return this.http
        .get(
          `${this.fixtureUrl}/${_sportIds}/${_categoryIds}/${_tournamentIds}/${this._DataHelper.leftMenuSportDayFilter}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`,
          { headers }
        )
        .toPromise()
        .then(r => {
          return r;
        })
        .catch(error => {
          return this.handleError(error);
        });
    }
  }

  getp1001UpcomingFixture(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(
      `/API/ProcFixtureUpcomingResult/0/-1/0/${this._DataHelper.leftMenuSportDayFilter}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`,
      {
        headers,
      }
    );
  }

  signIn(loginDataRaw: any): Promise<any> {
    if (loginDataRaw == undefined) {
      return;
    }

    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('username', loginDataRaw.userName);
    urlParams.append('password', loginDataRaw.userPassword);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    // GTM
    pushToDataLayer({ event: 'login' });

    return this.http
      .post(this.signInUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);

        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));

        return responseData;
      })
      .catch(error => {
        const t_message = this._TranslateService.instant('errorcode500');
        this._UiHelper.errorSnackBar(t_message, '');
        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));
        window.location.href = '/home';
        return '';
      });
  }

  signOut(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(this.signOutUrl, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getClient(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(this.getClientUrl)
      .toPromise()
      .then((r: any) => {
        this._UserHelper.isInsicStatus = r.IsInsic;
        this._UserHelper.IsLimitSet = r.IsLimitSet;
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getClient2(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(this.getClient2Url + '/' + this._UserHelper.customerUser.CustomerId)
      .toPromise()
      .then((r: any) => {
        this._UserHelper.customerUser.Balance = r.Balance;
        this._UserHelper.customerUser.BalanceAmount = r.BalanceAmount;
        this._UserHelper.customerUser.Bonus = r.Bonus;
        this._UserHelper.customerUser.IsCashOutInfo = r.IsCashOutInfo;
        return this._UserHelper.customerUser;
      })
      .catch(e => {
        if (e.status == 401) {
          // console.warn("401 ERROR");
          return false;
        }
      });
  }

  getCountryInfo(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get('/API/GetCountryInfo')
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getSearch(q): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    q = q.replace(' ', '+');

    return this.http
      .get(`${this.getSearchUrl}/${q}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getSearchSlipNumber(q): Promise<any> {
    // const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('SlipId', q);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(`${this.getSearchSlipNumberUrl}`, body, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getBookings(_month = 1, _year = 2019, _tid = 0): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.bookingsUrl}/${this._LocalizationService.LANGID}/${_month}/${_tid}/${_year}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTranscationsTypes(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.transcationTypesUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getWalletList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getWalletListUrl}/${this._UserHelper.customerUser.CustomerId}`, { headers })
      .toPromise()
      .then((r: Array<any>) => {
        if (r && r.length > 0) {
          this._UserHelper.walletList = r;
          this._UserHelper.emailIsVerified = r[0].IsVerification;
          const selectedWallet = r.filter(selectedWallet => selectedWallet.CustomerId == this._UserHelper.customerUser.CustomerId);
          if (selectedWallet && selectedWallet.length > 0) {
            this._DataHelper.selectedWallet = selectedWallet[0];
          }
          this._UserHelper.ResetDialogListener.emit(true);
          if (this._DataHelper.selectedWallet.IsFreeBetBonus) {
            this.getFreebetBonusInfo();
          } else if (this._DataHelper.selectedWallet.IsBoostBonus) {
            this.getBoostBonusInfo();
          }
          return r;
        }
      })
      .catch(error => {
        // return this.handleError(error);
      });
  }
  getBoostBonusInfo(typeId = 1): Promise<any> {
    //typeId=1 quotenboost,2 freebet
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.bonusBoostFreeBetUrl}/${this._UserHelper.customerUser.CustomerId}/${typeId}`, { headers })
      .toPromise()
      .then((r: Array<any>) => {
        if (r && r.length > 0) {
          this._DataHelper.customerBoostBonusInfo = r[0];

          return r;
        } else {
          this._DataHelper.customerBoostBonusInfo = null;
        }
      })
      .catch(error => {
        // return this.handleError(error);
      });
  }
  getFreebetBonusInfo(typeId = 2): Promise<any> {
    //typeId=1 quoten,2 freebet
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.bonusBoostFreeBetUrl}/${this._UserHelper.customerUser.CustomerId}/${typeId}`, { headers })
      .toPromise()
      .then((r: Array<any>) => {
        if (r && r.length > 0) {
          this._DataHelper.customerFreeBetBonusInfo = r[0];

          return r;
        } else {
          this._DataHelper.customerFreeBetBonusInfo = null;
        }
      })
      .catch(error => {
        // return this.handleError(error);
      });
  }
  forgotPassword(forgotPasswordDataRaw: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('email', forgotPasswordDataRaw.email);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getForgotPasswordUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);

        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  forgotPassword2(forgotPasswordDataRaw: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('email', forgotPasswordDataRaw.email);
    urlParams.append('birthday', forgotPasswordDataRaw.birthDay);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getForgotPasswordUrl2, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);

        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSlips(_month = 1, _year = 2019, _tid = 0): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.slipByDateUrl}/${this._LocalizationService.LANGID}/${_tid}/${this._LocalizationService.TIMEZONE}/${_month}/${_year}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        const t_message = this._TranslateService.instant('errorcode5');
        this._UiHelper.errorSnackBar(t_message, '');
        return '';
      });
  }

  changePassword(changePasswordDatas: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('changeoldpassword', changePasswordDatas.oldPassword);
    urlParams.append('changenewpassword', changePasswordDatas.newPassword);
    urlParams.append('changenewrepassword', changePasswordDatas.reNewPassword);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    // this.checkOnlineStatus();
    return this.http
      .post(this.changePasswordUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  addOdd(oddId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('OddId', oddId);
    urlParams.append('BetType', '0');
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    this.SelectOddBooleanValue(true);

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    return this.http
      .post(this.addOddUrl, body, { headers })
      .toPromise()
      .then((response: any) => {
        this.slipCurrents = response;
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        this.getSelectedOdds();
        // comp.getSelectedOdds();
        this.getCurrentSlip();
        return '';
      })
      .catch(error => {
        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));
        return '';
      });
  }

  addLiveOdd(oddId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('OddId', oddId);
    urlParams.append('BetType', '1');
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    this.SelectOddBooleanValue(true);

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    return this.http
      .post(this.addOddUrl, body, { headers })
      .toPromise()
      .then((response: any) => {
        this.slipCurrents = response;
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        this.getSelectedOdds();
        // comp.getSelectedOdds();
        this.getCurrentSlip();
      })
      .catch(error => {
        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));
        return '';
      });
  }
  SelectOddBooleanValue(value: boolean): void {
    if (['p1012'].includes(environment.product)) {
      this._DataHelper.isSelectOdd = false;

      setTimeout(() => {
        this._DataHelper.isSelectOdd = true;
      }, 100);
    }
  }

  addOddDirectly(newOdd, onlyPushAction = false): void {
    const indexOfOdd = this.slipCurrents.filter(e => e.OddId1 == newOdd.OddId1);
    this.SelectOddBooleanValue(true);

    if (indexOfOdd.length > 0) {
      // Don't remove if onlyPushAction is true,
      if (!onlyPushAction) {
        this.slipCurrents = this.slipCurrents.filter(e => e.OddId1 != newOdd.OddId1);
      }
    } else {
      this.slipCurrents.push(newOdd);
    }

    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));

    this.getCurrentSlip();
  }

  addOddDirectlyWithoutNotify(newOdd): void {
    const indexOfOdd = this.slipCurrents.filter(e => e.OddId1 == newOdd.OddId1);
    this.SelectOddBooleanValue(true);

    if (indexOfOdd.length > 0) {
      this.slipCurrents = this.slipCurrents.filter(e => e.OddId1 != newOdd.OddId1);
    } else {
      this.slipCurrents.push(newOdd);
    }
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));
  }

  getSelectedOdds(): Promise<OddModel[]> {
    return null;
  }

  getEventDetails(_matchid = 0, _groupid = 2): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.eventDetailUrl}/${_matchid}/${this._LocalizationService.LANGID}/${_groupid}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getEvent(_matchid = 0): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.eventUrl}/${_matchid}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSlipDetail(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.slipDetailUrl}/${this._LocalizationService.LANGID}/${_slipId}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        const t_message = this._TranslateService.instant('errorcode5');
        this._UiHelper.errorSnackBar(t_message, '');
        return '';
      });
  }

  getCouponDetailBySlipId(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.couponDetailBySlipIdUrl}/${this._LocalizationService.LANGID}/${_slipId}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return '';
      });
  }
  getCustomerSlipDetailTemp(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.customerSlipDetailTempUrl}/${this._LocalizationService.LANGID}/${_slipId}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return '';
      });
  }

  getSelfLimits(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getSelfLimitsUrl}/`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  quickRegister(quickRegisterDatas: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('Email', quickRegisterDatas.eMail);
    urlParams.append('BirthName', quickRegisterDatas.lastName);
    urlParams.append('IsPromotion', quickRegisterDatas.IsPromotion);
    urlParams.append('BirthPlace', quickRegisterDatas.birthPlace);
    urlParams.append('Country', quickRegisterDatas.country);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.quickRegisterUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  cashoutInfo(): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.customerCashoutInfoUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  switchWallet(CustomerId, BranchId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    urlParams.append('CustomerId', CustomerId);
    urlParams.append('BranchId', BranchId);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.switchWalletrUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this._UiHelper.setLoadingDialog(false);
      });
  }

  saveSelfLimits(LimitAmount, LimitType, TimeType): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('LimitAmount', LimitAmount);
    urlParams.append('LimitType', LimitType);
    urlParams.append('TimeType', TimeType);

    urlParams.append('LangId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.saveSelfLimitsUrl2, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCurrentSlip(): Promise<any> {
    this._DataHelper.setCurrentSlipData(this.slipCurrents);
    return;
  }

  currentSlipRemoveOdd(oddId): void {
    const ixofevent = this.slipCurrents.findIndex(o => o.OddId1 == oddId);
    this.slipCurrents.splice(ixofevent, 1);
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));

    this.getSelectedOdds();
    this.getCurrentSlip();
  }

  clearCurrentSlip(): any {
    this.slipCurrents = [];
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);

    this.getSelectedOdds();
    this.getCurrentSlip();

    return 1;
  }

  clearSlipSystem(): any {
    this._DataHelper.currentSlipSystemInfo = [];
    this._DataHelper.currentSlipSystemSelection = [];
  }

  getCurrentSlipAmount(amount, slipType, values = '', isFreeBet = false, isBoostBonus = false, BonusRate = 1): any {
    this.flagCurrentSlipAmount = true;

    let newValues = '';

    // Trigger when current Tab selected to 2, System
    if (this._UiHelper.currentSlipTabSelected == 2) {
      newValues = values;
    } else {
      newValues = '';
    }

    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('stake', amount);
    urlParams.append('sliptype', slipType);
    urlParams.append('values', newValues);
    urlParams.append('isFreeBet', isFreeBet.toString());
    urlParams.append('isBoostBonus', isBoostBonus.toString());
    urlParams.append('BonusRate', BonusRate.toString());

    const slipstring = JSON.stringify(this.slipCurrents);
    urlParams.append('currentslip', slipstring);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getCurrentSlipAmountUrl, body, { headers })
      .toPromise()
      .then(response => {
        this.flagCurrentSlipAmount = false;
        return response;
      })
      .catch(error => {
        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));
        return null;
      });
  }

  placeBet(amount, slipType, values): Promise<any> {
    try {
      const urlParams = new URLSearchParams();
      urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
      urlParams.append('device_id', this.seonResult);

      urlParams.append('stake', amount);
      urlParams.append('sliptype', slipType);
      urlParams.append('langId', this._LocalizationService.LANGID.toString());
      urlParams.append('langcode', this._LocalizationService.LANGCODE.toString());
      urlParams.append(
        'values',
        this._DataHelper.currentSlipSystemInfo
          .map((systemVal, index, array) => {
            return this._DataHelper.currentSlipSystemSelection.includes(`${systemVal.index + 1}_${systemVal.combination}`)
              ? `1${array.length === index + 1 ? '' : ','}`
              : `0${array.length === index + 1 ? '' : ','}`;
          })
          .join('')
      );
      urlParams.append('isFreebetBonus', (!this._DataHelper.freebetBonusCheckBox).toString());

      if (this._DataHelper.boostBonusCheckBox) {
        urlParams.append('boostBonusId', '-1');
      } else {
        urlParams.append('boostBonusId', '0');
      }

      localStorage.setItem('lastStakeAmount', JSON.stringify(this._DataHelper.currentSlipInfo.currentslip_totalStake));

      if (this._DataHelper.currentSlipSystemSelection.length === 0 && this._UiHelper.currentSlipTabSelected === 2) {
        this._UiHelper.errorSnackBar(this._TranslateService.instant('current_slip_core_text_2'), '');
        this._UiHelper.setLoadingDialog(true);

        return Promise.reject(false);
      }

      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.antiForgeryToken,
        }),
        observe: 'response' as 'body',
        responseType: 'text' as const,
      };

      const slipstring = JSON.stringify(this.slipCurrents);
      urlParams.append('currentslip', slipstring);
      const body = urlParams.toString();

      return this.http
        .post(this.getPlaceBetUrl, body, options)
        .toPromise()
        .then((response: any) => {
          try {
            if (typeof betaluxBr !== 'undefined' && betaluxBr.isActive('betrecommend')) {
              const isWithBr = this.slipCurrents.some(slip => slip.WithBr === true);
              const onlyBrTotalOddValue = this.slipCurrents.filter(slip => slip.WithBr === true).reduce((acc, slip) => acc * slip.OddValue1, 1);
              const marketIds = this.slipCurrents.map(slip => slip.OddId1);
              betaluxBr.get('betrecommend').sendSlip({
                isSuccess: response.body.split('|')[0] == 'success' ? true : false,
                marketIds: marketIds,
                withBr: isWithBr ? 'true' : 'false',
                reason: response.body.split('|')[1],
                slipId: response.body.split('|')[2],
                oddIncreasePercentage: onlyBrTotalOddValue,
              });
            }
          } catch (e) {
            console.warn(e);
          }

          return response;
        })
        .catch(error => {
          return this.handleError(error);
        });
    } catch (err) {
      console.log(err);
      return Promise.reject(err);
    }
  }

  placeBetTemp(amount, slipType, values, slipCurrents?): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('stake', amount);
    urlParams.append('sliptype', slipType);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('langcode', this._LocalizationService.LANGCODE.toString());
    const a = this._DataHelper.currentSlipSystemInfo
      .map((systemVal, index, array) => {
        return this._DataHelper.currentSlipSystemSelection.includes(`${systemVal.index + 1}_${systemVal.combination}`)
          ? `1${array.length === index + 1 ? '' : ','}`
          : `0${array.length === index + 1 ? '' : ','}`;
      })
      .join('');
    urlParams.append('values', values || a);
    if (this._DataHelper.currentSlipSystemSelection.length === 0 && this._UiHelper.currentSlipTabSelected === 2) {
      this._UiHelper.errorSnackBar(this._TranslateService.instant('current_slip_core_text_2'), '');
      this._UiHelper.setLoadingDialog(true);

      return Promise.reject(false);
    }

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.antiForgeryToken,
      }),
      observe: 'response' as 'body',
      responseType: 'text' as const,
    };

    const slipstring = JSON.stringify(slipCurrents || this.slipCurrents);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    this._DataHelper.qrCodeBookBetBody = {
      amount: amount,
      slipType: slipType,
      values: a,
      currentslip: slipCurrents || this.slipCurrents,
    };

    return this.http
      .post(this.getPlaceBetTempUrl, body, options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        this._UiHelper.setLoadingDialog(false);
        return this.handleError(error);
      });
  }

  userLoggedInSuccessfully(): Promise<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.antiForgeryToken,
      }),
      observe: 'response' as 'body',
      responseType: 'text' as const,
    };
    return this.http
      .get(`${this.getLoginRefresh}`, options)
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSystemItems(): Promise<any> {
    const urlParams = new URLSearchParams();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const slipstring = JSON.stringify(this._DataHelper.currentSlipData);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();
    return this.http
      .post(`${this.getSystemItemsUrl}`, body, { headers })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  checkEmailUsage(email: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getEmailCheck}/${email}/`, { headers })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  changeSelectedSlipCurrent(enable, bank, oddId): any {
    const urlParams = new URLSearchParams();

    const _odd = this.slipCurrents.filter(s => s.OddId1 == oddId);

    if (_odd != undefined && _odd.length > 0) {
      _odd[0].Enable = enable;
      _odd[0].Banko = bank;
    }
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));
    this.getCurrentSlip();
    return this.slipCurrents;
  }

  signUp(data): Promise<any> {
    const birthDay = data.bday;
    let countryid = '1';
    if (data.country != undefined && data.country != '') {
      countryid = data.country;
    }

    let currencyid = '1';
    let username = data.mail;

    if (data.currency != undefined) {
      currencyid = data.currency;
    }

    if (data.username != undefined && data.username != '') {
      username = data.username;
    }

    const urlParams = new URLSearchParams();
    urlParams.append('address', data.address);
    urlParams.append('ssn', data.agreement);
    urlParams.append('branch', data.bayi);
    urlParams.append('birthday', birthDay);
    urlParams.append('birthplace', data.bplace);
    urlParams.append('countryid', countryid);
    urlParams.append('currencyId', currencyid);
    urlParams.append('email', data.mailf);
    urlParams.append('password', data.password);
    urlParams.append('repassword', data.re_password);
    urlParams.append('phone', data.phone);
    urlParams.append('taxno', data.tax_no);
    urlParams.append('promotion_permission', data.promotion_permission);
    urlParams.append('firstname', data.userFName);
    urlParams.append('lastname', data.userLName);
    urlParams.append('username', username);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('timeZone', this._LocalizationService.TIMEZONE.toString());
    urlParams.append('city', data.city);
    urlParams.append('zip', data.zip);
    urlParams.append('housenumber', data.housenumber);
    urlParams.append('phonecodeid', data.phonecodeid);
    urlParams.append('titleId', data.titleId);
    urlParams.append('birthName', data.birthName);
    urlParams.append('nationalty', data.nationalty);
    urlParams.append('prefferedLang', data.prefferedLang ?? 6);
    urlParams.append('isBonus', data.isBonus ?? false);
    urlParams.append('GroupId', data.moneySource);
    urlParams.append('passportnumber', data.pass_no);
    urlParams.append('idnumber', data.citizenship_number);

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('device_id', this.seonResult);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getSignUpUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        this._UiHelper.setLoadingDialog(false);

        const t_message = this._TranslateService.instant('errorcode3');
        this._UiHelper.successSnackBar(t_message, '');
        return this.handleError(error);
      });
  }

  saveAffiliation(cid, iacookies): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('cid', cid);
    urlParams.append('ia_affid', iacookies.ia_affid);
    urlParams.append('btag', iacookies.btag);
    urlParams.append('siteid', iacookies.siteId);
    urlParams.append('playerid', iacookies.playerid);
    urlParams.append('timeStamp', iacookies.timeStamp);
    // ia_affid, string btag, string siteid, string playerid

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.saveAffiliationUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSaluteList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getSaluteListUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return '';
      });
  }

  getCountryListLang(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getCountryUrl2}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSignUpFields(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getSignUpFieldsUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTaxRate(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getTaxRateUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCashoutSlipsExternal(_tid = 1): Promise<any> {
    this.flagCashoutSlipsExternal = true;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const apiurl = CashoutURL + 'CashOutSlipsExternal';

    let currentcid = '1';
    if (this._UserHelper.customerUser != undefined && this._UserHelper.customerUser.CustomerId != undefined) {
      currentcid = this._UserHelper.customerUser.CustomerId;
    }
    return this.http
      .get(`${apiurl}/${currentcid}/${this._LocalizationService.LANGID}/${_tid}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        this._DataHelper.setCashoutData(r);
        // this.dataCashoutSlipsExternal = r;
        this.flagCashoutSlipsExternal = false;
        return r;
      })
      .catch(error => {
        const t_message = this._TranslateService.instant('errorcode5');
        this._UiHelper.errorSnackBar(t_message, '');
        this.flagCashoutSlipsExternal = false;
        return '';
      });
  }

  getCashoutValueExternal(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const apiurl = CashoutURL + 'CashoutDetailExternal';
    return this.http
      .get(
        environment.isNewCashout
          ? `${environment.newCashoutUrl}/cashoutValue?id=${_slipId}&langID=${this._LocalizationService.LANGID.toString()}`
          : `${apiurl}/${this._LocalizationService.LANGID}/${_slipId}/${this._LocalizationService.TIMEZONE}`,
        { headers }
      )
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return '';
      });
  }

  cashOutPay(_slipId, _cashOutValue): Promise<any> {
    const urlParams = new URLSearchParams();
    // CashOutValue SlipId LangId
    urlParams.append('CashOutValue', _cashOutValue);
    urlParams.append('SlipId', _slipId);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(environment.isJacktimeActive ? this.getCashOutPayJacktimeUrl : this.getCashOutPayUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  cashoOutPayAnonymous(_slipId, _cashOutValue): Promise<any> {
    const urlParams = new URLSearchParams();
    // CashOutValue SlipId LangId
    urlParams.append('CashOutValue', _cashOutValue);
    urlParams.append('SlipId', _slipId);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getCashOutPayAnonUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  refreshCurrentSlip(): Promise<any> {
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    if (this.flag_control_refreshcurrentslip == 1) {
      return Promise.resolve('flag_control_refreshcurrentslip');
    }

    this.flag_control_refreshcurrentslip = 1;

    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    return this.http
      .post(`${this.refreshCurrentSlipUrl}/${this._LocalizationService.LANGID}`, body, { headers })
      .toPromise()
      .then((r: any) => {
        if (this._UiHelper.flagRefreshCurrentSlip) {
          this.slipCurrents = r;
          const slipstring = JSON.stringify(this.slipCurrents);
          localStorage.setItem('currentslip', slipstring);
          this.getCurrentSlip();
        }
        this.flag_control_refreshcurrentslip = 0;
        return r;
      })
      .catch(c => {
        this.flag_control_refreshcurrentslip = 0;
        return '';
      });
  }

  // refresh slip

  getCasbackStatus(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.cashbackStatusUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCashbackBalance(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.cashbackBalanceUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  joinCashback(): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    const body = urlParams.toString();
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(`${this.joinCashbackUrl}`, body, { headers: headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getAllWithdrawControl(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getAllWithdrawControlUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositOnlineUeber1({ amount }): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amount);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('API/DepositUeber', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getWithdrawBanks(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getWithdrawBanksUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }

  withdrawBanks1({ banksDatasRaw, bankId }): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('bankId', bankId);
    urlParams.append('accountNo', banksDatasRaw.de_accountNo);
    urlParams.append('ssn', banksDatasRaw.ssn);
    urlParams.append('nameSurname', banksDatasRaw.nameSurname);
    urlParams.append('withdrawamount', banksDatasRaw.banksAmount);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getBanksWithdrawUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);
  }

  getOutrightSports(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightSportsUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  getOutrightCategories(sportId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightCategoriesUrl}/${sportId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getOutrightEvents(categoryId, sportId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightEventsUrl}/${categoryId}/${sportId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getOutrightMatchOdds(matchId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightMatchOddsUrl}/${matchId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  // getOutrightMatchOddsbyTourIdUrl
  getOutrightMatchOddsbyTourId(matchId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightMatchOddsbyTourIdUrl}/${matchId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  addOutrightsOdd(oddId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('OddId', oddId);
    urlParams.append('BetType', '2');
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    this.SelectOddBooleanValue(true);

    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.addOddUrl, body, { headers })
      .toPromise()
      .then((response: any) => {
        this.slipCurrents = response;
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        this.getSelectedOdds();
        // comp.getSelectedOdds();
        this.getCurrentSlip();
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCustomerTicket(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getGetCustomerTicketUrl}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getCustomerTicketDetail(ticketId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getCustomerTicketDetailUrl}/${ticketId}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  AnswerTicketMessage(ticketDatas, FilePath, Subject): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('TicketId', ticketDatas.TicketId);
    urlParams.append('Subject', Subject);
    urlParams.append('Message', ticketDatas.Message);
    urlParams.append('FilePath', FilePath);
    urlParams.append('ActivityCode', ticketDatas.ActivityCode);
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getAnswerTicketMessageUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  UploadtoAWS(file, subpath): Promise<any> {
    const formData = new FormData();
    formData.append('__RequestVerificationToken', this.antiForgeryToken.toString());
    formData.append('subpath', subpath);
    formData.append('file', file);

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken);
    // .set('Content-Type', 'application/json');

    return this.http
      .post(this.getUploadtoAWSUrl, formData, { headers })

      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return { ...responseData, name: file.name };
      })
      .catch(() => {
        this._UiHelper.setLoadingDialog(false);
        return this.handleError;
      });
  }

  UploadtoAWSFromSupport(file, subpath): Promise<any> {
    const formData = new FormData();
    formData.append('__RequestVerificationToken', this.antiForgeryToken.toString());
    formData.append('subpath', subpath);
    formData.append('file', file);

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken);
    // .set('Content-Type', 'application/json');

    return this.http
      .post(this.getUploadtoAWSFromSupportUrl, formData, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  getCustomerOne(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getGetCustomerOneUrl}`, { headers })
      .toPromise()
      .then(response => {
        /* this._UiHelper.setLoadingDialog(false);*/
        return response;
      })
      .catch(err => {
        const t_message = this._TranslateService.instant('errorcode5');
        this._UiHelper.errorSnackBar(t_message, '');
        return '';
      });
    /*this._UiHelper.setLoadingDialog(false);*/
  }

  getComboPhoneNumberList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getComboPhoneNumberUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getComboPasswordQuestionList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getComboPasswordQuestionUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  saveCustomerDetail(data): Promise<any> {
    ////// console.log("this.userprofileDataRaw", data);
    const urlParams = new URLSearchParams();
    urlParams.append('customerName', data.CustomerName);
    urlParams.append('customerSurname', data.CustomerSurname);
    urlParams.append('address', data.Address || '');
    urlParams.append('addressAdditional', data.AddressAdditional);
    urlParams.append('city', data.City);
    urlParams.append('countryId', data.CountryId);
    urlParams.append('eMail', data.Email);
    urlParams.append('phoneNumber', data.PhoneNumber);
    urlParams.append('phoneCodeId', data.PhoneCodeId);
    urlParams.append('passwordQuestion', '');
    urlParams.append('passwordQuestionId', data.PasswordQuestionId);
    urlParams.append('passwordQuestion', data.PasswordAnswer);

    urlParams.append('oddchangehigher', data.IsOddIncreasement);
    urlParams.append('oddchangelower', data.IsOddDecreasements);
    urlParams.append('idnumber', data.IdNumber);
    urlParams.append('passportnumber', data.PassportNo);
    urlParams.append('birthplace', data.BirthPlace);
    urlParams.append('taxno', data.TaxNo);
    urlParams.append('promotionPermission', data.PromotionPermission);
    urlParams.append('birthday', data.Birthday);
    urlParams.append('housenumber', data.OddsFormatId);
    urlParams.append('zip', data.ZipCode);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('timeZone', this._LocalizationService.TIMEZONE.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getSaveCustomerDetailUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  cloudFiles(data, a): Promise<any> {
    /*////console.log("RESiM", data);*/
    const urlParams = new URLSearchParams();
    urlParams.append('DocumentId', data.DocumentTypeCombo);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('Link', a);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getCloudFilesUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  uploadDocumentToAWSApi(file, data): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken);

    return this.http
      .post(`${this.uploadDocumentToAWS}/${data.DocumentTypeCombo}/${this._LocalizationService.LANGID.toString()}`, formData, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError)
      .finally(() => {
        this._UiHelper.setLoadingDialog(false);
      });
  }

  getUploadFilesControl(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getUploaddocControl}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  getUnreadMessage(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getUnreadMessageUrl}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(err => {
        console.error(err);
      });
  }

  getPagesbyName(pageTitle): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getPagebyTitleUrl}/${pageTitle}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  getSearch4Favs(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    //// console.log("favs", this._UserHelper.favoriedMatches);
    // fav filter
    let _favs = '';
    if (this._UserHelper.favoriedMatches != undefined && this._UserHelper.favoriedMatches.length > 0) {
      this._UserHelper.favoriedMatches.forEach(event => {
        _favs += event + ',';
      });
    } else {
      _favs = '0';
    }
    // fav filter

    return this.http
      .get(`${this.getSearch4FavsUrl}/${_favs}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`)
      .toPromise()
      .then(r => {
        //// console.log(r);
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  mailConfirm(confirmkey, langId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('confirmkey', confirmkey);
    urlParams.append('langId', langId);
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getMailConfirmUrl, body, { headers })
      .toPromise()
      .then(response => {
        /*this._UiHelper.setLoadingDialog(false);*/

        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    /*this._UiHelper.setLoadingDialog(false);*/
  }

  recoverPassword(recoverPasswordDatas: any, recoverykey, langId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('recoverykey', recoverykey);
    urlParams.append('changenewpassword', recoverPasswordDatas.newPassword);
    urlParams.append('changenewrepassword', recoverPasswordDatas.reNewPassword);
    urlParams.append('langId', langId);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.recoverPasswordUrl, body, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(response);
        let responseData: any;
        responseData = JSON.parse(response as string);
        ////// console.log(responseData);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  refreshAuthToken(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'text/html');
    const options = { headers, responseType: 'text' as const };
    return this.http
      .get(`/Login/Refresh/`, options)
      .toPromise()
      .then(r => {
        document.getElementById('cont_antiforgerytoken').innerHTML = r;
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getLinkVirtualGoldenRace(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/VirtualGoldenRace/`, { headers })
      .toPromise()
      .then(r => {
        //// console.log("VIRTUAL GOLDEN RACE URL", r);
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getScannerSlipDetail(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getScannerSlipDetailUrl}/${this._LocalizationService.LANGID}/${_slipId}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        const t_message = this._TranslateService.instant('errorcode5');
        this._UiHelper.errorSnackBar(t_message, '');
        return '';
      });
  }

  getScannerSlipOneBySlipIdAndPass(_slipId, slipPassword): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getScannerSlipOneBySlipIdAndPassUrl}/${this._LocalizationService.LANGID}/${_slipId}${slipPassword}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return '';
      });
  }

  slipRestore(slipId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('slipId', slipId);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.slipRestoreUrl, body, { headers })
      .toPromise()
      .then((response: any) => {
        this.slipCurrents = response;
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        this.getSelectedOdds();

        this.getCurrentSlip();
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  helpMail(userName, email, category, problem, message): Promise<any> {
    const error_message = this._TranslateService.instant('help_mail_error');
    const success_message = this._TranslateService.instant('help_mail_success');

    const urlParams = new URLSearchParams();

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post(`${this.helpMailUrl}/${userName}/${email}/${category}/${problem}/${message}`, body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        if (responseData == 'success') {
          this._UiHelper.successSnackBar(success_message, '');
        } else if (responseData == 'error') {
          this._UiHelper.errorSnackBar(error_message, '');
        }
        return response;
      })
      .catch(error => {
        this._UiHelper.setLoadingDialog(false);
        this._UiHelper.errorSnackBar(error_message, '');
        return this.handleError(error);
      });
  }

  AWSGetImage(imageLink): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('imageLink', imageLink);

    const body = urlParams.toString();
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };
    return this.http
      .post(this.AWSGetImageUrl, body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(error => {
        this._UiHelper.setLoadingDialog(false);
        return this.handleError(error);
      });
  }

  bookingLoginResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.bookingLoginResultUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  CasinoGameCreateToken(sessionId): Promise<any> {
    this._UiHelper.setLoadingDialog(true);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/Casino/CreateGameToken/` + sessionId, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);
  }

  procCustomerQrCodeResult(BranchId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.procCustomerQrCodeResultUrl}/${BranchId}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  accountLock24(): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('lockDayCount', '1');
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getAccountLockUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);

        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcAccountLockDayResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.procAccountLockDayResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerAccountLockNewResult(LockDayCount: number, LockDayReason: any): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    LockDayReason = LockDayReason || 1;
    return this.http
      .get(`${this.procCustomerAccountLockNewResultUrl}/${LockDayCount}/${LockDayReason}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcAccountLockReasonResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.procAccountLockReasonResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  withdrawCancel(withdrawReqId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('withdrawReqId', withdrawReqId);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    const body = urlParams.toString();
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http
      .post(this.postWithDrawCancelUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  getProcCustomerBonusTrackerResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerBonusTrackerResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerBonusOnlineTracker1Result(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerBonusOnlineTracker1ResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerBonusTracker1Result(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerBonusTracker1ResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcTournamentTopResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcTournamentTopResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerContract(IsContractAccepted: boolean): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.ProcCustomerContractUrl}/${IsContractAccepted}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerIBANUIDResult(customerId, Iban): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerIBANUIDResultUrl}/${customerId}/${Iban}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getQuickRegisterInfo(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getQuickRegisterUrl}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getCasinoRegisterInfo(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getCasinoRegisterInfoUrl}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  saveCasinoRegister(quickRegisterDatas: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('Email', quickRegisterDatas.eMail);
    urlParams.append('BirthPlaceCity', quickRegisterDatas.birthPlace);
    urlParams.append('BirthplaceCountry', quickRegisterDatas.country);
    urlParams.append('PhoneNumber', quickRegisterDatas.PhoneNumber);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(`${this.getCasinoRegisterInfoUrl}/Update`, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTournamentStatisticp1001(sportId: number, categoryId: number, tournamentID: number): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.ProcMatchStandingResultUrl}/${sportId}/${categoryId}/${tournamentID}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  checkPassword(password: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    urlParams.append('password', password);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    // this.checkOnlineStatus();
    return this.http
      .post(this.postPasswordControl, body, { headers })
      .toPromise()
      .then(response => {
        //// console.log(response);

        //// console.log(responseData);
        // this.configureClient();
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSearchp1001(q): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    q = q.replaceAll(' ', '');

    return this.http
      .get(`${this.getSearchp1001Url}/${q}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`)
      .toPromise()
      .then(r => {
        //// console.log(r);
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTransactionHistory(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getTransactionHistoryUrl}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getResendConfirmationMail(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getResendConfirmationMailUrl}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getOddComparison(): Promise<any> {
    const urlParams = new URLSearchParams();

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getOddComparisonUrl}?langId=${this._LocalizationService.LANGID.toString()}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  signalrConnection(state: boolean): void {
    if (state) {
      this._SignalrServiceLegacy.startConnection();
      this._SignalrServiceLegacy.signalRTimer();
      return;
    }
    this._SignalrServiceLegacy.stopConnection();
    this._SignalrServiceLegacy.disposeSignalRTimer();

    return;
  }
  getSliderWeb(v: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.sliderWebUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  autoWithdrawReq(IsActive: boolean, Withdrawlimit: number): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('IsActive', IsActive.toString());
    urlParams.append('Withdrawlimit', Withdrawlimit.toString());
    const body = urlParams.toString();
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http
      .post(this.AutoWithdrawAutoReqUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTvStreamingList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.liveStreamUrl}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  private isMobile(): boolean {
    return /Mobi|Android/i.test(navigator.userAgent);
  }
  postBetradarLiveStreamURL(streamId: string, mute: boolean): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const deviceId = this.isMobile() ? 2 : 1; // Cihaz türünü belirle

    return this.http

      .post(
        `${this.betradarStreamVideoUrl}`,
        {
          streamId,
          Mute: mute,
          DeviceId: deviceId, // Cihaz ID'sini kullan
        },
        { headers }
      )

      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => (e.status == 401 ? false : this.handleError(e)));
  }

  getBetradarLiveStreamList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .post(`${this.betradarLiveStreamUrl}`, {}, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => (e.status == 401 ? false : this.handleError(e)));
  }

  getCustomerTeamList(): Promise<any> {
    //Kullanıcının teamliste eklediği takımların listesi
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.CustomerTeamListUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        this._UiHelper.customerMyTeamData = r;

        if (this._UiHelper.customerMyTeamData && this._UiHelper.customerMyTeamData.length > 0) {
          const all_text = this._TranslateService.instant('AllMyTeam');
          const totalEventCount = this._UiHelper.customerMyTeamData.reduce((accumulator, currentObject) => {
            return accumulator + currentObject.EventCount;
          }, 0);
          const allObject = {
            ExtensionData: {},
            CompetitorId: -1,
            CompetitorName: all_text,
            EventCount: totalEventCount,
          };
          this._UiHelper.customerMyTeamData.unshift(allObject);

          return r;
        } else {
          this._UiHelper.customerMyTeamData = [];
        }
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  addCustomerTeamList(teamId: any): Promise<any> {
    //Kullanıcının teamliste eklediği metot

    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('teamId', teamId);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(`${this.CustomerTeamUIDUrl}`, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getTopListTicket(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getTopListTicketUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  addMarketToSlip(markets: any[]) {
    for (const market of markets) {
      const _outcome = market.marketOutcome;
      const _market = market.marketTypeText;

      const _betType = 0;

      // 07-03-2022 - SpecialBetValue Parantez kaldırıldı. Sebebi : İlk data da Parantezli geliyordu. Sonra refresh olunca gidiyordu parantez !
      // 07-03-2022 - Soccer için specialIsActive eklendi. Böylece Data ilk geldiğinde SpecialBetValue olmadığında Score gösterilmiş oldu !
      const newOdd = {
        Banko: false,
        BetType: _betType,
        Enable: true,
        EventDateLong: market.eventDate,
        EventName: market.eventName,
        MatchId: market.eventId,
        OddId1: parseInt(market.marketId),
        OddsType: _market,
        OddsTypeId: market.marketType,
        OddValue1: market.marketValue,
        OutCome: _outcome,
        ShortOddType: _market,
        // "SpecialBetValue": e['OddSpecialBetValue' + a.lineText] != undefined ? e['OddSpecialBetValue' + a.lineText] : '',
        SpecialBetValue: market.specialMarketValue,
        Visibility: '',
        HomeTeam: market.homeTeamName,
        AwayTeam: market.awayTeamName,
        WithBr: true,
      };

      this.addOddDirectly(newOdd, true);
    }
  }
  sonnenspieleCasinoLaunch(): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('Casino/Sonnenspiele/Launch', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return JSON.parse(response);
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getMySlipsLiveMatchList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .post(`${this.mySlipLiveMatchListUrl}`, headers)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getFavFixture(matchId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = {
      MatchIdList: matchId,
      LangId: this._LocalizationService.LANGID,
      TimeZone: this._LocalizationService.TIMEZONE,
    };
    return this.http
      .post(`${this.procFixtureUrl}`, body, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getCasinoProviderList(CategoryId: string | number): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.casinoProviderList}/${CategoryId}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getCasinoGameList({ page, limit, providerId, categoryId, searchValue }: casinoGamesListApiType): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.casinoGameList}/${providerId}/${categoryId}/${limit}/${page}${searchValue ? `/${searchValue}` : ''}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getCasinoCategoriesList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.casinoGetCategories}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getCasinoSoftmayaUrl(Id: number, client: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .post(`${this.casinoSoftmayaUrl}/${Id}/${this._LocalizationService.LANGID}/${client}`, headers)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getCasinoFavGameList({ page, limit }: casinoFavGamesListApiType): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.casinoFavoriteByCustomerUrl}/${limit}/${page}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  casinoFavAddAndRemove({ gameId, eventType }: casinoFavAddAndRemoveApiType): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .post(`${this.casinoFavoriteAddUrl}/${gameId}/${eventType}`, headers)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getCasinoMostFavorites({ count }: casinoMostFavoritesApiType): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.casinoMostFavoritesUrl}/${count}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getCasinoSlider(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.casinoSliderUrl}/${this._LocalizationService.LANGID}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getPromotionPage(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getPromotionPageUrl}/${this._LocalizationService.LANGID}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getPromotionCount(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getPromotionCountUrl}/${this._LocalizationService.LANGID}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  customerSlipWildCard(SlipOddId, OddValue): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('SlipOddId', SlipOddId);
    urlParams.append('OddValue', OddValue);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.customerSlipWildCardUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this._UiHelper.setLoadingDialog(false);
      });
  }
  postLiveStreamURL(streamId: string, mute: boolean): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const deviceId = this.isMobile() ? 2 : 1; // Cihaz türünü belirle

    return this.http

      .post(
        `${this.liveStreamVideoUrl}`,
        {
          matchId: streamId,
          Mute: mute,
          DeviceId: deviceId, // Cihaz ID'sini kullan
        },
        { headers }
      )

      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => (e.status == 401 ? false : this.handleError(e)));
  }
  getLiveStreamEventsList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.LiveStreamEventsUrl}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => (e.status == 401 ? false : this.handleError(e)));
  }
  /*
EN ALTTA KALMALI
 */

  handleError(error: any): Promise<any> {
    // console.error('An error occurred', error);
    if (error.status == 401) {
      this._UserHelper.signInListener.emit(false);
      return Promise.reject(error.message || error);
    }
    return Promise.reject(error.message || error);
  }
}
